import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProposalBillingItemService } from 'app/services/http/proposal-billing-item.service';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
    billProposalBillingItem,
    billProposalBillingItemFailure,
    billProposalBillingItemSuccess,
    loadProposalBillingItems,
    loadProposalBillingItemsFailure,
    loadProposalBillingItemsSuccess,
    payProposalBillingItem,
    payProposalBillingItemFailure,
    payProposalBillingItemSuccess,
} from './proposal-billing-item.actions';

@Injectable()
export class ProposalBillingItemEffects {
    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadProposalBillingItems),
            switchMap(({ proposalId }) =>
                this.service.findAll(proposalId).pipe(
                    map((response) => loadProposalBillingItemsSuccess({ proposalId, items: response.data || [] })),
                    catchError((error) => of(loadProposalBillingItemsFailure({ error })))
                )
            )
        )
    );

    bill$ = createEffect(() =>
        this.actions$.pipe(
            ofType(billProposalBillingItem),
            switchMap(({ proposalId, itemId, date }) =>
                this.service.bill(proposalId, itemId, { date }).pipe(
                    map((item) => billProposalBillingItemSuccess({ proposalId, item })),
                    catchError((error) => of(billProposalBillingItemFailure({ error })))
                )
            )
        )
    );

    pay$ = createEffect(() =>
        this.actions$.pipe(
            ofType(payProposalBillingItem),
            switchMap(({ proposalId, itemId, date }) =>
                this.service.pay(proposalId, itemId, { date }).pipe(
                    map((item) => payProposalBillingItemSuccess({ proposalId, item })),
                    catchError((error) => of(payProposalBillingItemFailure({ error })))
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private service: ProposalBillingItemService
    ) { }
}
